import { render, staticRenderFns } from "./basicInformation.vue?vue&type=template&id=352fd06c&scoped=true&"
import script from "./basicInformation.vue?vue&type=script&lang=js&"
export * from "./basicInformation.vue?vue&type=script&lang=js&"
import style0 from "./basicInformation.vue?vue&type=style&index=0&id=352fd06c&scoped=true&lang=scss&"
import style1 from "./basicInformation.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352fd06c",
  null
  
)

export default component.exports